"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var axios_1 = __importDefault(require("axios"));
var App_1 = __importDefault(require("./App"));
var wildfires_1 = require("../../store/reducers/wildfires");
var map_1 = require("../../store/reducers/map");
var getClassBreakRenderer_1 = require("../../utils/getClassBreakRenderer");
var AppConfig_1 = require("../../AppConfig");
var AppContainer = function () {
    var definitionExpression = react_redux_1.useSelector(wildfires_1.definitionExpressionSelector);
    var dispatch = react_redux_1.useDispatch();
    var initApp = function () { return __awaiter(void 0, void 0, void 0, function () {
        var WildfiresLayerUrl, WildfireLayerClassificationField, classbreakRenderer, wildfires, formattedWildfires;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    WildfiresLayerUrl = AppConfig_1.MapConfig.WildfiresLayerUrl, WildfireLayerClassificationField = AppConfig_1.MapConfig.WildfireLayerClassificationField;
                    return [4, getClassBreakRenderer_1.getClassBreakRenderer({
                            url: WildfiresLayerUrl,
                            where: definitionExpression,
                            classificationField: WildfireLayerClassificationField,
                        })];
                case 1:
                    classbreakRenderer = _a.sent();
                    return [4, fecthWildfires()];
                case 2:
                    wildfires = _a.sent();
                    formattedWildfires = assignClassBreak2WildfireFeatures(wildfires, classbreakRenderer);
                    dispatch(map_1.loadWildfireLayerRenderer(classbreakRenderer));
                    dispatch(wildfires_1.loadWildfires(formattedWildfires));
                    return [2];
            }
        });
    }); };
    var fecthWildfires = function () { return __awaiter(void 0, void 0, void 0, function () {
        var WildfiresLayerUrl, requestUrl, data, features, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    WildfiresLayerUrl = AppConfig_1.MapConfig.WildfiresLayerUrl;
                    requestUrl = WildfiresLayerUrl + "/query?f=json&where=" + definitionExpression + "&outFields=*";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, axios_1.default.get(requestUrl)];
                case 2:
                    data = (_a.sent()).data;
                    features = data.features;
                    return [2, features];
                case 3:
                    err_1 = _a.sent();
                    console.error('failed to load wildfires', err_1);
                    return [2, []];
                case 4: return [2];
            }
        });
    }); };
    var assignClassBreak2WildfireFeatures = function (features, classbreakRenderer) {
        var classBreakInfos = classbreakRenderer.classBreakInfos, field = classbreakRenderer.field;
        return features.map(function (feature) {
            for (var i = 0, len = classBreakInfos.length; i < len; i++) {
                if (feature.attributes[field] <= classBreakInfos[i].classMaxValue) {
                    feature.classBreak = i;
                    break;
                }
            }
            return feature;
        });
    };
    React.useEffect(function () {
        initApp();
    }, []);
    return (React.createElement(App_1.default, null));
};
exports.default = AppContainer;
